var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-loading",class:_vm.className},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orbit-spinner"},[_c('div',{staticClass:"orbit"}),_c('div',{staticClass:"orbit"}),_c('div',{staticClass:"orbit"})])
}]

export { render, staticRenderFns }